(function($){
    // JS
    window.Tabs = {

        // Tabs
        //======================================================================
        tabs: function()
        {
            $(document).ready(function(){

                $('ul.tabs li').removeClass('current');
                $('.tab-content').removeClass('current');
                $('.tab-content .categories-content').removeClass('current');

                $('ul.tabs li:first-child').addClass('current');
                $('ul.tabs li:first-child').css('background',$('ul.tabs li:first-child').attr('data-active-color'));

                $('.tab-content:first').addClass('current');
                $('.tab-content .categories-content:first').addClass('current');

                $(document).on('click', 'ul.tabs li', function(e){
                    var tab_id = $(this).attr('data-tab');
            
                    $('ul.tabs li').removeClass('current');
                    $('.tab-content').removeClass('current');
                    $('.tab-content .categories-content').removeClass('current');
                    $('.tab-content li button').removeClass('current');

                    $(this).addClass('current');
                    $("ul.tabs li").each(function(){
                        $(this).css('background',$(this).attr('data-inactive-color'));
                    });
                    $("#"+tab_id).addClass('current');
                    $("#"+tab_id+ " .sub-categories li:first-child button").addClass('current');
                    $("#"+tab_id+ " .categories-content:first").addClass('current');

                    $(this).parent().css('border-color',$(this).attr('data-active-color'));
                    $(this).css('background',$(this).attr('data-active-color'));

                });
            
            })
        },
        subFilters: function()
        {
            $('ul.sub-categories li:first-child button').addClass('current');

            $(document).on('click', 'ul.sub-categories li button', function(e){
                e.preventDefault();

                var tab_id = $(this).data('js-sub-cat');
            
                $('ul.sub-categories li button').removeClass('current');
                //$('ul.sub-categories').removeClass('tab-1 tab-2 tab-3');
                $('.categories-content').removeClass('current');
        
                $(this).addClass('current');
                $(this).parent().addClass(tab_id);
                $('#'+tab_id).addClass('current');
            });
        }
    }
    // Run
    $(function(){
        Tabs.tabs();
        Tabs.subFilters();
    });


}(jQuery));